import Vue from 'vue';

Vue.directive('autofocus', {
    inserted(el, binding) {
        if (binding.value) {
            el.focus();
        }
    }
});
